export const L10N = {
  ACTION_CHANGE_DESTINATION: { id: 'lisa.action.change_destination' },
  ACTION_CLOSE: { id: 'common.action.close' },

  LABEL_ASSISTANT: { id: 'lisa.label.assistant' },
};
